/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi.com Payments API
 * An API for Kiwi.com payments.
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { StoredCardValidityFromJSON, StoredCardValidityToJSON, } from './StoredCardValidity';
/**
 * @export
 */
export const StoredCardLogoIdEnum = {
    Amex: 'Amex',
    DinersClub: 'DinersClub',
    Elo: 'Elo',
    Jcb: 'JCB',
    MaestroShort: 'MaestroShort',
    MasterCardShort: 'MasterCardShort',
    ChinaUnionPay: 'ChinaUnionPay',
    Visa: 'Visa',
    Discover: 'Discover',
    Mir: 'MIR'
};
/**
 * Check if a given object implements the StoredCard interface.
 */
export function instanceOfStoredCard(value) {
    if (!('cardType' in value) || value['cardType'] === undefined)
        return false;
    if (!('isPreselected' in value) || value['isPreselected'] === undefined)
        return false;
    if (!('maskedCardNumber' in value) || value['maskedCardNumber'] === undefined)
        return false;
    if (!('token' in value) || value['token'] === undefined)
        return false;
    if (!('validity' in value) || value['validity'] === undefined)
        return false;
    return true;
}
export function StoredCardFromJSON(json) {
    return StoredCardFromJSONTyped(json, false);
}
export function StoredCardFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'cardType': json['card_type'],
        'isPreselected': json['is_preselected'],
        'logoId': json['logo_id'] == null ? undefined : json['logo_id'],
        'maskedCardNumber': json['masked_card_number'],
        'token': json['token'],
        'validity': StoredCardValidityFromJSON(json['validity']),
    };
}
export function StoredCardToJSON(json) {
    return StoredCardToJSONTyped(json, false);
}
export function StoredCardToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'card_type': value['cardType'],
        'is_preselected': value['isPreselected'],
        'logo_id': value['logoId'],
        'masked_card_number': value['maskedCardNumber'],
        'token': value['token'],
        'validity': StoredCardValidityToJSON(value['validity']),
    };
}
